import React from 'react';
import { useSelector } from 'react-redux';
import FeatureFlag from '../../features/components/FeatureFlag';
import { FEATURES } from '../../features/components/constants';
import CoachBounceRouteShim from '../../../lib/CoachBounceRouteShim';
import Home from './Home';

export default function HomeGuard() {
    const haveFeaturesLoaded = useSelector(
        state => Object.keys(state.features).length > 0
    );

    if (!haveFeaturesLoaded) {
        return null;
    }
    return (
        <FeatureFlag
            feature={FEATURES.WEB_COACH_HOME}
            fallback={() => {
                return <CoachBounceRouteShim />;
            }}
        >
            <Home />
        </FeatureFlag>
    );
}
